import { render, staticRenderFns } from "./imgJ.vue?vue&type=template&id=7769ed63&scoped=true"
var script = {}
import style0 from "./imgJ.vue?vue&type=style&index=0&id=7769ed63&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7769ed63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7769ed63')) {
      api.createRecord('7769ed63', component.options)
    } else {
      api.reload('7769ed63', component.options)
    }
    module.hot.accept("./imgJ.vue?vue&type=template&id=7769ed63&scoped=true", function () {
      api.rerender('7769ed63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgJ.vue"
export default component.exports